import { IUserResponse } from 'interfaces/user';

const notShortString = (str: string): boolean => str?.length > 1;

export const getUserName = (user: IUserResponse) => {
  if (user.fullName && notShortString(user.fullName)) return user.fullName;
  if (user.username && notShortString(user.username)) return user.username;
  if (user.email) return user.email;
};
